import {Debugger} from "debug";
import {AgendaelementId, DokumentId, ImporterGoogleDokumentISakSpesifikasjon, SaksdokumentModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {Injectable} from "@angular/core";
import {GoogleDriveFil} from "./GoogleDriveFilvelgerGui";
import {DokumentOgEksisterende, SkyfilOpplasting} from "web-ng2/delt/komponenter/filvelger-skytjenester/SkyfilOpplasting";
import {SaksdokumentDatatjeneste} from "felles-ng2/tjenester/datalager/SaksdokumentDatatjeneste";

const debug: Debugger = require('debug')('OneDriveOpplasting');

/**
 * Tjeneste for opplasting av dokumenter fra google drive til styreplan.
 * Merk at vi i motsetning til i {@link SakWebRessurs} ikke tar oss bryderiet med å vise dokumenter i GUI med progresjonsindikator mens disse lastes opp.
 *
 * For fremdrift kan kaller av registrerGoogleDokumenter() lytte til notify callback i promiset.
 */
@Injectable()
export class GoogleDriveOpplasting extends SkyfilOpplasting<ImporterGoogleDokumentISakSpesifikasjon, GoogleDriveFil> {

    constructor(private avhengigheter: GoogleDriveOpplastingAvhengigheter) {
        super(debug);
    }

    // SkyfilOpplasting implementasjon

    protected somSpesifikasjon(fil: DokumentOgEksisterende<GoogleDriveFil>, aksessToken: string): ImporterGoogleDokumentISakSpesifikasjon {
        return {
            filId: fil.fil.filId,
            navn: fil.fil.filnavn,
            mimetype: fil.fil.mimeType,
            url: fil.fil.url,
            oauthToken: aksessToken
        };
    }

    protected registrerNyttDokument(sakId: AgendaelementId, spesifikasjon: ImporterGoogleDokumentISakSpesifikasjon): Promise<SaksdokumentModell> {
        return this.avhengigheter.registrerNyttDokument(sakId, spesifikasjon);
    }

    protected registrerNyDokumentVersjon(sakId: AgendaelementId, dokumentId: DokumentId, spesifikasjon: ImporterGoogleDokumentISakSpesifikasjon): Promise<SaksdokumentModell> {
        return this.avhengigheter.registrerNyDokumentVersjon(sakId, dokumentId, spesifikasjon);
    }
}


@Injectable()
export class GoogleDriveOpplastingAvhengigheter {

    constructor(private saksdokumentDatatjeneste:SaksdokumentDatatjeneste) {
    }

    registrerNyttDokument(id: AgendaelementId, spesifikasjon: ImporterGoogleDokumentISakSpesifikasjon): Promise<SaksdokumentModell> {
        return this.saksdokumentDatatjeneste.registrerGoogleDokumentISak(id, spesifikasjon);
    }

    registrerNyDokumentVersjon(id: AgendaelementId, dokumentId: DokumentId, spesifikasjon: ImporterGoogleDokumentISakSpesifikasjon): Promise<SaksdokumentModell> {
        return this.saksdokumentDatatjeneste.registrerGoogleDokumentSomDokumentversjon(id, dokumentId, spesifikasjon);
    }
}
